import i18n from 'modules/core/lib/i18n'

import { LOCATION_TYPES } from 'modules/attendance/store/models/Shift'

/**
 * Resolves the effective location type for a shift.
 *
 * When a shift has no explicit locationType but has an associated workplace,
 * it is inferred as "office". This is the single source of truth for this
 * inference — all surfaces (day-to-day view, breakdown panel, etc.) must use
 * this function instead of inlining the logic.
 */
export const resolveShiftLocationType = (
  locationType: string | null | undefined,
  hasWorkplace: boolean
): string | undefined => locationType ?? (hasWorkplace ? LOCATION_TYPES.OFFICE : undefined)

export const locationTypeText = (location_type: string) => {
  switch (location_type) {
    case LOCATION_TYPES.WORK_FROM_HOME:
      return i18n.t('clock_in.locations.select_options.work_from_home')
    case LOCATION_TYPES.OFFICE:
      return i18n.t('clock_in.locations.select_options.office')
    case LOCATION_TYPES.BUSINESS_TRIP:
      return i18n.t('clock_in.locations.select_options.business_trip')
    default:
      return ''
  }
}

export const locationTypeOptions = () => [
  {
    label: locationTypeText(LOCATION_TYPES.OFFICE!),
    value: LOCATION_TYPES.OFFICE,
  },
  {
    label: locationTypeText(LOCATION_TYPES.WORK_FROM_HOME!),
    value: LOCATION_TYPES.WORK_FROM_HOME,
  },
  {
    label: locationTypeText(LOCATION_TYPES.BUSINESS_TRIP!),
    value: LOCATION_TYPES.BUSINESS_TRIP,
  },
]
